class CarouselHome extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
    this._container = null;
    this._wrapper = null;
    this._pagination = null;
    this._prev = null;
    this._next = null;
  }

  connectedCallback() {
    // Guard if Swiper isn’t loaded yet (defer race)
    if (!window.Swiper) {
      // Try once more after the current tick
      setTimeout(() => this.connectedCallback(), 0);
      return;
    }
    if (this._swiper) return;

    this._buildStructure();
    this._initSwiper();
  }

  disconnectedCallback() {
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }

  _buildStructure() {
    // Original children are <carousel-slide> elements
    const slides = Array.from(this.children);

    // Outer container required by Swiper
    this._container = document.createElement('div');
    this._container.className = 'swiper home-carousel-swiper';

    // Wrapper required by Swiper
    this._wrapper = document.createElement('div');
    this._wrapper.className = 'swiper-wrapper';

    // Move each <carousel-slide> into wrapper and mark as .swiper-slide
    slides.forEach((slideEl) => {
      slideEl.classList.add('swiper-slide');
      this._wrapper.appendChild(slideEl);
    });

    // Controls
    this._pagination = document.createElement('div');
    this._pagination.className = 'swiper-pagination';

    this._prev = document.createElement('button');
    this._prev.className = 'swiper-button-prev';
    this._prev.setAttribute('aria-label', 'Previous slide');
    this._prev.type = 'button';

    this._next = document.createElement('button');
    this._next.className = 'swiper-button-next';
    this._next.setAttribute('aria-label', 'Next slide');
    this._next.type = 'button';

    // Build DOM
    this._container.appendChild(this._wrapper);
    this._container.appendChild(this._pagination);
    this._container.appendChild(this._prev);
    this._container.appendChild(this._next);

    // Replace light DOM content with Swiper structure
    this.innerHTML = '';
    this.appendChild(this._container);
  }

  _initSwiper() {
    // Read options from data attributes if desired (with sane defaults)
    const autoplayMs = Number(this.dataset.autoplay) || 5000;
    const loop = this.dataset.loop !== 'false'; // default true
    const speed = Number(this.dataset.speed) || 600;
    const spaceBetween = Number(this.dataset.spaceBetween) || 0;
    const slidesPerView = Number(this.dataset.slidesPerView) || 1;

    this._swiper = new Swiper(this._container, {
      loop,
      speed,
      spaceBetween,
      watchOverflow: true,
      centeredSlides: false,
      slidesPerView: 1, // Always 1 on mobile
      // Enable keyboard and a11y helpers
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        enabled: true,
        containerMessage: 'Homepage carousel',
        slideRole: 'group',
      },
      // Pagination bullets
      pagination: {
        el: this._pagination,
        clickable: true,
      },
      // Prev/Next
      navigation: {
        nextEl: this._next,
        prevEl: this._prev,
      },
      // Autoplay (pause on hover for desktop)
      autoplay:
        autoplayMs > 0
          ? {
              delay: autoplayMs,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      // Responsive breakpoints - use configured slidesPerView on desktop
      breakpoints: {
        768: {
          slidesPerView: slidesPerView,
        },
      },
    });
  }
}

customElements.define('carousel-home', CarouselHome);
